import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const PartnerCtaSection = () => (
    <section id="cta" className="lp-partner-cta" style={{ marginBottom: '0' }}>
        <div className="lp-partner-cta-inner">
            <h2 data-lp-reveal>Ready to reach high-intent SMEs?</h2>
            <p data-lp-reveal data-lp-delay="60">A 20-minute call gets you listed.</p>
            <div className="lp-partner-cta-btns" data-lp-reveal data-lp-delay="120">
                <a className="lp-partner-cta-btn lp-partner-cta-btn--solid" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
            </div>
        </div>
    </section>
);

export default PartnerCtaSection;
